import { Check, KeyboardReturn } from '@mui/icons-material'
import React from 'react'

import {
  OptionBody,
  OptionDescription,
  OptionLabel,
  OptionNumber,
  OptionRow,
  PreviewBox,
  TrailingIcon,
} from 'features/ask-yogi/components/ask-user-input-widget.styles'
import type { AskUserQuestionOption } from 'features/ask-yogi/types'

export type AskUserInputOptionsProps = {
  options: AskUserQuestionOption[]
  selectedLabels: string[]
  keyboardIndex: number
  isReadOnly: boolean
  rowIdPrefix: string
  onActivate: (label: string) => void
}

export const AskUserInputOptions: React.FC<AskUserInputOptionsProps> = ({
  options,
  selectedLabels,
  keyboardIndex,
  isReadOnly,
  rowIdPrefix,
  onActivate,
}) => (
  <>
    {options.map((option, index) => {
      const isSelected = selectedLabels.includes(option.label)
      const isFocused = index === keyboardIndex
      return (
        <React.Fragment key={option.label}>
          <OptionRow
            id={`${rowIdPrefix}-opt-${index}`}
            $keyboardFocused={isFocused}
            $selected={isSelected}
            $readOnly={isReadOnly}
            role="option"
            aria-selected={isSelected}
            onClick={() => onActivate(option.label)}
          >
            <OptionNumber $keyboardFocused={isFocused} $selected={isSelected}>
              {index + 1}
            </OptionNumber>
            <OptionBody>
              <OptionLabel $keyboardFocused={isFocused} $selected={isSelected}>
                {option.label}
              </OptionLabel>
              {option.description && (
                <OptionDescription>{option.description}</OptionDescription>
              )}
            </OptionBody>
            {isSelected ? (
              <TrailingIcon>
                <Check sx={{ fontSize: 14 }} />
              </TrailingIcon>
            ) : (
              isFocused && (
                <TrailingIcon>
                  <KeyboardReturn sx={{ fontSize: 14 }} />
                </TrailingIcon>
              )
            )}
          </OptionRow>
          {(isSelected || isFocused) && option.preview && (
            <PreviewBox>{option.preview}</PreviewBox>
          )}
        </React.Fragment>
      )
    })}
  </>
)
